import { FC } from "react"
import { SchedulesList } from "../../../../module/schedules/containers/list"

export const SchedulesSafetiesListPage: FC = () => <SchedulesList />
